import { render, staticRenderFns } from "./PendingReissue.vue?vue&type=template&id=2ce46a49&"
import script from "./PendingReissue.vue?vue&type=script&lang=js&"
export * from "./PendingReissue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports